<script setup>
import GroupedButtons from "../GroupedButtons.vue";
import {ref, watch} from "vue";

const emit = defineEmits(['step', 'change']);
const {value, selected} = defineProps(['value', 'selected']);

const pass = selected[1].items;

const selected_fitness_access = ref(value.fitness ?? 1);

const labels = [
    'Une séance',
    'Deux séances',
    'Trois séances',
    'Quatre séances',
    'Cinq séances',
];

const fitness_access = Object.fromEntries( labels.map( (value, index) => {
    if ( index + 1 <= pass.length ) {
        return [ index + 1, value ];
    }

    return null;
} ).filter( value => value !== null ) );

const formula = ref( pass.find( formula => formula.times === selected_fitness_access.value ) );

function next() {
    emit('step', 'account');

    emit('change', {
        dance: 0,
        fitness: selected_fitness_access.value,
    });
}

watch( selected_fitness_access, nbr_access => formula.value = pass.find( formula => formula.times === nbr_access ) );
</script>

<template>
    <div class="flex flex-col">
        <div class="flex flex-col lg:flex-row mb-10">
            <div class="mb-10 lg:mb-0">
                <button class="button-invert px-5 py-2" type="button" @click="emit('step', 'previous')"><i class="fa-solid fa-angle-left | mr-2"></i> Retour</button>
            </div>
            <h2 class="text-white text-4xl text-center lg:w-10/12">Choix du nombre de cours</h2>
        </div>

        <div class="flex flex-col mb-5">
            <div class="text-xl text-center text-white mb-5">Combien de séances de <span class="uppercase border-b">fitness</span> par semaine ?</div>
            <grouped-buttons class="w-full lg:w-8/12 mx-auto" @input="value => selected_fitness_access = parseInt( value )" :value="selected_fitness_access.toString()"
                             :choices="fitness_access"></grouped-buttons>
        </div>

        <div class="text-white text-xl font-bold text-center mb-10">
            {{ formula.times }} séance{{ formula.times > 1 ? 's' : '' }} / semaine<br/>
            <template v-if="selected[1].subscription_period === 'full_season'">
                {{ formula.price }} &euro; / SAISON
            </template>
            <template v-if="selected[1].subscription_period !== 'full_season'">
                {{ formula.price }} &euro; / DEMI-SAISON
            </template>
        </div>

        <div class="text-center">
            <button class="button px-5 py-3" type="button" @click="next">Suivant <i class="fa-solid fa-angle-right | ml-2"></i></button>
        </div>
    </div>
</template>